import React from 'react';
import {PcIllustratedFour} from './pc/PcIllustratedFour'; // 注意这里是默认导入
import {MobileIllustratedFour} from './mobile/MobileIllustratedFour'; // 注意这里是默认导入

function IllustratedFour({isMobile, clicked, clickNext, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileIllustratedFour {...commonProps} />;
    } else {
        return <PcIllustratedFour {...commonProps} />;
    }
}

export default IllustratedFour;